<div class="flex flex-col p-4">
  <div class="flex flex-row mb-2 items-center">
    <span class="font-bold mr-1">Username:</span>
    <span class="font-normal">{{ username() }}</span>
  </div>
  <div class="flex flex-row mb-2 items-center">
    <span class="font-bold mr-1">Email:</span>
    <span class="font-normal text-sm">{{ email() }}</span>
  </div>
  <hr class="w-full !border-gray-400" />
  <div class="flex flex-col gap-3">
    <a class="!font-semibold !text-[#7E8299] !cursor-pointer" (click)="logout()">
      Sign out
    </a>
  </div>
</div>
